import _ from "lodash";

export const geocodeAddress = (geocoder, fullAddress) => {
  const {
    address,
    city,
    state,
    country,
    postal_code: postalcode
  } = fullAddress;
  // console.log("fullAddress=", fullAddress);
  // for all available search params see:
  // https://developer.here.com/documentation/geocoder/topics/resource-geocode.html
  const params = {
    searchtext: address,
    city,
    state,
    country,
    postalcode
  };
  // console.log("geocoding", params);
  return new Promise((resolve, reject) => {
    geocoder.geocode(
      params,
      result => {
        const geoPoint = _.get(
          result,
          "Response.View[0].Result[0].Location.DisplayPosition"
        );
        if (!_.isUndefined(geoPoint)) {
          const { Latitude, Longitude } = geoPoint;
          // console.log("geocode result:", result, Latitude, Longitude);
          resolve({ lat: Latitude, lng: Longitude });
        } else {
          // console.log("no populated geocode result", result, geoPoint);
          resolve({});
        }
      },
      err => reject(err)
    );
  });
};



// WEBPACK FOOTER //
// ./src/modules/geocoding/geocoding.js